export const HoraCertaHeader = () => (
  <header className="mb-6">
    <div className="flex items-center gap-2">
      <h1 className="font-GilroyBold text-2xl text-slate-900">
        Importar Planilha
      </h1>
    </div>
    <p className="text-sm text-slate-600 mt-1">
      Selecione uma planilha Hora Certa para revisar seus dados antes da
      importação.
    </p>
  </header>
);
